import { addToChainAfter, addToChainBefore, replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    LoadProducts,
} from "@insite/client-framework/Store/Components/ProductCarousel/Handlers/LoadCarouselProducts";
import loadProductInfoList from "@insite/client-framework/Store/Components/ProductInfoList/Handlers/LoadProductInfoList";

// this will enable HMR for custom handlers
if (module.hot) {
    module.hot.accept();
    const originalChain = chain.slice();
    module.hot.dispose(data => {
        chain.length = 0;
        originalChain.forEach(o => chain.push(o));
    });
}

addToChainBefore(chain, LoadProducts, props => {
    const {
        parameter: { carouselType, numberOfProductsToDisplay, isBrandDetailsPage, brand },
    } = props;

    if (carouselType !== "brandProducts" || !isBrandDetailsPage || !brand) {
        return;
    }

    const brandIds = isBrandDetailsPage && brand ? [brand.id] : [];

    props.getProductCollectionParameter = {
        pageSize: numberOfProductsToDisplay,
        brandIds,
    };
});

replaceInChain(chain, LoadProducts, props => {
    if (!props.getProductCollectionParameter) {
        return;
    }

    const extraProductOptions = props.extraProductCollectionParameter
        ? {
              getProductCollectionParameter: props.extraProductCollectionParameter,
              numberOfProductsToDisplay: props.parameter.numberOfProductsToDisplay,
          }
        : undefined;

    const isRecentlyViewedOnPDP =
        props.parameter.carouselType === "recentlyViewed" && props.parameter.isProductDetailsPage;

    props.getProductCollectionParameter.expand
        ? props.getProductCollectionParameter.expand.push("images", "badges", "properties")
        : (props.getProductCollectionParameter.expand = ["images", "badges", "properties"]);

    props.dispatch(
        loadProductInfoList({
            id: props.parameter.carouselId,
            getProductCollectionParameter: props.getProductCollectionParameter,
            extraProductOptions,
            excludeProductId: isRecentlyViewedOnPDP ? props.parameter.productId : undefined,
            forceLoad: isRecentlyViewedOnPDP,
            isShellEdit: props.parameter.isShellEdit,
        }),
    );
});
